import Tabs from "components/tabs/Tabs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./portalLoyaltyProgram.scss";
import LoyaltyProgramCards from "./loyaltyProgramCards/LoyaltyProgramCards";
import { ILoyaltyCustomer, ILoyaltyProgram, IReward, ITier } from "redux/reducers/models/loyalty";
import { TFunction } from "i18next";
import LoyaltyProgramRecentActivity from "./loyaltyProgramRecentActivity/LoyaltyProgramRecentActivity";
import LoyaltyProgramRewards from "./loyaltyProgramRewards/LoyaltyProgramRewards";
import LoyaltyProgramDetails from "./loyaltyProgramDetails/LoyaltyProgramDetails";

interface IProps {
    loyaltyCustomer: ILoyaltyCustomer;
    expiringPoints: number;
    tiers: Array<ITier>;
    rewards: Array<IReward>;
    loyaltyProgram: ILoyaltyProgram;
}

enum LoyaltyTabs {
    ACTIVITY = 0,
    REWARDS = 1,
    INFO = 2,
}


export default function PortalLoyaltyProgramView(props: IProps) {
    const {loyaltyCustomer, expiringPoints, tiers, rewards, loyaltyProgram} = props;
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState<LoyaltyTabs>(LoyaltyTabs.ACTIVITY);
    const tabs = loyaltyTabs(t, loyaltyProgram?.type);
    
    return (
        <div className="portal-loyalty-program-view">
            <LoyaltyProgramCards points={loyaltyCustomer?.points_balance} expiringPoints={expiringPoints} tiers={tiers} currentTierId={loyaltyCustomer?.selected_tier_id}/>
            <br />
            <Tabs tabs={tabs} selected={selectedTab} onSelect={tab => setSelectedTab(tab)}>
            <br />
            {selectedTab === LoyaltyTabs.ACTIVITY ? (
                <LoyaltyProgramRecentActivity customer={loyaltyCustomer}/>
            ) : selectedTab === LoyaltyTabs.REWARDS ? (
                <LoyaltyProgramRewards tiers={tiers} rewards={rewards} customer={loyaltyCustomer} loyaltyProgram={loyaltyProgram} />
            ) : selectedTab === LoyaltyTabs.INFO ? (
                <LoyaltyProgramDetails loyaltyProgram={loyaltyProgram} />
            ) : null}
            </Tabs>
        </div>
    );
}


const loyaltyTabs = (t: TFunction<"translation", undefined>, type: "tier_based" | "points_based") => [
    {
        content: t("Recent activity"),
    },
    {
        content: type === "tier_based" ? t("Tier rewards") : t("Rewards"),
    },
    {
        content: t("How it works"),
    },
];